export interface NetworkConfigurationPlugin {
  connect(options: { ssid: string; password: string }): Promise<void>;
}
